<template>
  <v-card class="pa-4 px-6" flat>
    <div class="d-flex align-center">
      <h3>Pedidos por status</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click="excel"><v-icon>mdi-download</v-icon></v-btn>
    </div>

    <v-divider class="ma-2"></v-divider>

    <v-data-table
      :items="items"
      :loading="loading"
      :headers="headers"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer>
        <div class="d-flex justify-end mr-8">
          <strong>Total de pedidos: </strong>
          <span class="ml-2">
            {{
              items
                .map((x) => x.salesCount)
                .reduce(function (a, b) {
                  return a + b;
                }, 0)
            }}
          </span>
        </div>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="pageCount"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
export default {
  name: "Skus",

  props: {
    filter: Object,
  },

  created() {
    this.list();
  },

  data() {
    return {
      pageCount: 1,
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
      items: [],
      loading: false,
      apiService: new ApiService(),
      headers: [
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Vendas (Quantidade)",
          value: "salesCount",
        },
        {
          text: "Vendas (Contábil)",
          value: "salesValue",
        },
      ],
      page: 1,
    };
  },

  methods: {
    list() {
      this.loading = true;

      this.apiService
        .post(
          "dashboard/byStatus",
          { ...this.filter, page: this.page },
          false,
        )
        .then((response) => {
          this.items = response.content.data;
          this.pageCount = response.content.pager.totalPages;
          this.totalItems = response.content.pager.totalItems;
          this.currentPage = response.content.pager.currentPage;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.page += 1;
      await this.list();
    },

    excel() {
      this.loading = true;

      this.apiService
        .post(
          "dashexport/byStatus",
          { ...this.filter, page: this.page },
          false,
          false,
          false
        )
        .then((response) => {
          const excel =
            "data:application/octet-stream;base64," + response.content;
          const link = document.createElement("a");
          link.href = excel;
          link.setAttribute("download", `status.xlsx`);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.list();
      },
    },
  },
};
</script>

<style></style>
